import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CoachEntry } from 'src/app/services/clarity-coach.service';

export interface ClariCoachDialogData {
  entries?: CoachEntry[];
}

@Component({
  selector: 'app-clari-coach-dialog',
  templateUrl: './clari-coach-dialog.component.html',
  styleUrls: ['./clari-coach-dialog.component.scss']
})
export class ClariCoachDialogComponent {
  entries: CoachEntry[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<ClariCoachDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data?: ClariCoachDialogData
  ) {
    this.entries = [...(data?.entries ?? [])].sort((a, b) => {
      const aTime = new Date(a.createdAt).getTime();
      const bTime = new Date(b.createdAt).getTime();
      return bTime - aTime;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  getModelName(entry: CoachEntry): string {
    return entry.assistantModelName || entry.assistantModelId || 'AI Model';
  }

  getSummary(entry: CoachEntry): string {
    const summary = (entry.summary || '').trim();
    if (summary) return summary;
    const suggestionText = (entry.suggestions ?? [])
      .map((suggestion) => suggestion.reason || suggestion.modelName || suggestion.modelId)
      .filter(Boolean)
      .join(' • ');
    return suggestionText || 'No coach summary available yet.';
  }

  formatTimestamp(value?: string): string {
    if (!value) return 'Recent';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return 'Recent';
    return parsed.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  }
}
